// extracted by mini-css-extract-plugin
module.exports = {"heroBackground":"blog_heroBackground__mM1M3","greenBlob":"blog_greenBlob__ng5rd","blueBlob":"blog_blueBlob__zTuso"};